module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component.css
// module id = ./src/app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component.css
// module chunks = main